module.exports = __webpack_public_path__ + "img/vitrafy-logo-black.59cb01be.png";